var map = {
	"./1/symbol_0.png": 35386,
	"./1/symbol_1.png": 25219,
	"./1/symbol_10.png": 65707,
	"./1/symbol_11.png": 28226,
	"./1/symbol_12.png": 84313,
	"./1/symbol_13.png": 78064,
	"./1/symbol_14.png": 90287,
	"./1/symbol_15.png": 51270,
	"./1/symbol_16.png": 32477,
	"./1/symbol_17.png": 99444,
	"./1/symbol_18.png": 94739,
	"./1/symbol_2.png": 40859,
	"./1/symbol_3.png": 34014,
	"./1/symbol_4.png": 67070,
	"./1/symbol_5.png": 42855,
	"./1/symbol_6.png": 92172,
	"./1/symbol_7.png": 26178,
	"./1/symbol_8.png": 74642,
	"./1/symbol_9.png": 96187
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 31626;